import React, { useEffect, useState } from "react";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import toast from "react-hot-toast";
import useFleetAssignment from "../../../../Hooks/useDriver";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";

const FleetAssignment = () => {
   const [selectedDriver, setSelectedDriver] = useState(null);
   const [selectedFleet, setSelectedFleet] = useState(null);
   const [isUpdating, setIsUpdating] = useState(false);
   const navigate = useNavigate();

   const {
      driverList,
      fleetList,
      rawDriverList,
      rawFleetList,
      getDriverList,
      getFleetList,
      updateFleetAssignment,
   } = useFleetAssignment();

   // Fetch both lists on mount
   useEffect(() => {
      getDriverList();
      getFleetList();
   }, []);

   // Derived detail objects from raw API data
   const driverDetail = rawDriverList.find((d) => d.id === selectedDriver);
   const fleetDetail = rawFleetList.find((f) => f.id === selectedFleet);

   const availableDriversTooltip = "Those drivers are shown in the list who are not assigned to any trip.";
   const availableFleetsTooltip = "Those vehicles are shown in the list which are not assigned to any trip.";

   const handleUpdate = async () => {
      if (!selectedDriver) {
         //toast.error("Please select a driver.");
         return;
      }
      if (!selectedFleet) {
         //toast.error("Please select a fleet vehicle.");
         return;
      }

      setIsUpdating(true);
      try {
         const response = await updateFleetAssignment({
            driver_id: selectedDriver,
            fleet_master_id: selectedFleet,
         });
         if (response?.data?.statusCode === 200) {
            navigate("/driver-master/view");
         }
      } catch (error) {
         //toast.error("Failed to update fleet assignment");
      } finally {
         setIsUpdating(false);
      }
   };

   return (
      <div>
         <BodyHeader title="Fleet Assignment" />

         <div className="p-3">
            <form
               className=" p-2"
               onSubmit={(e) => {
                  e.preventDefault();
                  handleUpdate();
               }}
            >
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Change Driver Fleet</h3>
                  </div>

                  <div className="card-body">
                     <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                           <CustomDropdown
                              require
                              label={
                                 <span className="d-inline-flex align-items-center">
                                    Select Driver
                                    <Tooltip title={availableDriversTooltip} arrow placement="top">
                                       <i
                                          className="fas fa-info-circle text-primary ml-1"
                                          style={{ cursor: "pointer", fontSize: "0.85rem" }}
                                       />
                                    </Tooltip>
                                 </span>
                              }
                              id="driver_select"
                              name="driver_select"
                              optionData={driverList}
                              value={selectedDriver}
                              onChange={(data) => {
                                 setSelectedDriver(data?.[0]?.value ?? null);
                              }}
                           />

                           {driverDetail && (
                              <div
                                 className="mt-2 p-3 rounded border"
                                 style={{
                                    backgroundColor: "#f0f6ff",
                                    borderColor: "#007bff",
                                 }}
                              >
                                 <p className="mb-1">
                                    <strong>Name:</strong> {driverDetail.name}
                                 </p>
                                 <p className="mb-1">
                                    <strong>Mobile:</strong> {driverDetail.mobile}
                                 </p>
                              </div>
                           )}
                        </div>

                        <div className="col-lg-6 col-md-6 col-12">
                           <CustomDropdown
                              require
                              label={
                                 <span className="d-inline-flex align-items-center">
                                    Select Fleet (Vehicle)
                                    <Tooltip title={availableFleetsTooltip} arrow placement="top">
                                       <i
                                          className="fas fa-info-circle text-primary ml-1"
                                          style={{ cursor: "pointer", fontSize: "0.85rem" }}
                                       />
                                    </Tooltip>
                                 </span>
                              }
                              id="fleet_select"
                              name="fleet_select"
                              optionData={fleetList}
                              value={selectedFleet}
                              onChange={(data) => {
                                 setSelectedFleet(data?.[0]?.value ?? null);
                              }}
                           />

                           {/* Fleet Detail Preview */}
                           {fleetDetail && (
                              <div
                                 className="mt-2 p-3 rounded border"
                                 style={{
                                    backgroundColor: "#f0fff4",
                                    borderColor: "#28a745",
                                 }}
                              >
                                 <p className="mb-0">
                                    <strong>Vehicle No:</strong> {fleetDetail.vehicle_no}
                                 </p>
                              </div>
                           )}
                        </div>
                     </div>

                     {selectedDriver && selectedFleet && (
                        <div
                           className="mt-4 p-3 rounded border d-flex align-items-center gap-3"
                           style={{ backgroundColor: "#fffbe6", borderColor: "#ffc107" }}
                        >
                           <i
                              className="fas fa-info-circle text-warning"
                              style={{ fontSize: "1.4rem" }}
                           />
                           <span>
                              <strong>{driverDetail?.name}</strong> will be assigned to
                              vehicle <strong>{fleetDetail?.vehicle_no}</strong>. Click{" "}
                              <strong>Update</strong> to confirm.
                           </span>
                        </div>
                     )}
                  </div>
               </div>

               <div className="col-12 mt-3 mb-2 text-center">
                  <button
                     type="submit"
                     className="btn btn-primary px-5 py-3"
                     disabled={isUpdating}
                  >
                     {isUpdating ? (
                        <>
                           <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                           />
                           Updating...
                        </>
                     ) : (
                        <h6 className="mb-0 text-uppercase">Update</h6>
                     )}
                  </button>
               </div>
            </form>
         </div>
      </div>
   );
};

export default FleetAssignment;
